import axios from 'axios';
import { getStoredAccessToken } from '../utils/auth0Utils';

// Create axios interceptor to add Authorization header to all requests
axios.interceptors.request.use(
  (config) => {
    // Get the token from localStorage
    const token = getStoredAccessToken();
    
    // If token exists, add it to the Authorization header
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;